import React, {
  createContext,
  Dispatch,
  ReactNode,
  SetStateAction,
  useContext,
  useState,
} from 'react'

type OverlayLoaderContextType = {
  loaderText: string
  overlayLoader: boolean
  setLoaderTxt: Dispatch<SetStateAction<string>>
  setOverlayLoader: Dispatch<SetStateAction<boolean>>
}

const OverlayLoaderContext = createContext<
  OverlayLoaderContextType | undefined
>(undefined)

export const OverlayLoaderProvider: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  const [overlayLoader, setOverlayLoader] = useState<boolean>(false)
  const [loaderText, setLoaderTxt] = useState<string>('')

  return (
    <OverlayLoaderContext.Provider
      value={{ loaderText, setLoaderTxt, overlayLoader, setOverlayLoader }}
    >
      {children}
    </OverlayLoaderContext.Provider>
  )
}

export const useOverlayLoader = () => {
  const context = useContext(OverlayLoaderContext)
  if (!context)
    throw new Error(
      'useOverlayLoader must be used within OverlayLoaderProvider'
    )
  return context
}
